<template>
    <div>
        <div class="block-header block-header-default">
            <h3 class="block-title">Transactions</h3>
        </div>
        <div class="block-content">
            <div class="table-responsive">
                <table class="table table-striped table-vcenter">
                    <thead>
                        <tr role="row">
                            <th class="text-center" tabindex="0">
                                #
                            </th>

                            <th style="width: 100px;" class="text-capitalize">
                                Transaction Date
                            </th>

                            <th class="text-capitalize">
                                Receiver's name
                            </th>
                            <th class="text-capitalize">
                                Destination Account
                            </th>
                            <th class="text-capitalize">
                                Amount
                            </th>
                            <th class="text-capitalize">
                                Status
                            </th>
                            <th class="text-capitalize">
                                Transaction Description
                            </th>
                            <th class="text-capitalize">
                                Debit/Credit
                            </th>
                            <th class="text-capitalize">
                                Transaction Type
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            role="row"
                            class="odd"
                            v-for="(transaction, index) in transactions"
                        >
                            <td class="text-center sorting_1">
                                {{ index + 1 }}
                            </td>

                            <td>
                                {{ transaction.when }}
                            </td>

                            <td>
                                {{ transaction.receiver_name }}
                            </td>
                            <td>
                                {{ transaction.receiver_account }}
                            </td>

                            <td>
                                {{ transaction.curr_symbol
                                }}{{
                                    parseFloat(transaction.amount)
                                        .toFixed(2)
                                        .replace(
                                            /(\d)(?=(\d{3})+(?!\d))/g,
                                            "$1,"
                                        )
                                }}
                            </td>

                            <td>
                                <span
                                    class="text-warning"
                                    v-if="transaction.status == 0"
                                    >Pending</span
                                >
                                <span class="text-success" v-else>Success</span>
                            </td>
                            <td>{{ transaction.description }}</td>
                            <td>
                                <span
                                    class="text-danger"
                                    v-if="transaction.is_credit == 0"
                                    >DEBIT</span
                                >
                                <span class="text-success" v-else>CREDIT</span>
                            </td>
                            <td class="text-uppercase">
                                {{ transaction.trans_option }} Transfer
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { RepositoryFactory as Repo } from "../../repository/RepositoryFactory";
const AR = Repo.get("users");
export default {
    components: {
        QrcodeVue
    },
    data() {
        return {
            transactions: []
        };
    },
    methods: {},
    created() {
        AR.getTransactions().then(response => {
            this.transactions = response.data;
        });
    }
};
</script>
